import React from 'react';
import { useTranslation } from 'react-i18next';

function StartScreen({ onStart }) {
  const { t } = useTranslation();

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      backgroundColor: 'rgba(0,0,0,0.7)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 100
    }}>
      <div 
        onClick={onStart}
        style={{
          width: '90%',
          maxWidth: '500px',
          padding: '24px',
          backgroundColor: 'white',
          borderRadius: '12px',
          textAlign: 'center',
          color: '#333',
          cursor: 'pointer',
          boxShadow: '0 10px 25px rgba(0,0,0,0.2)'
        }}
      >
        <h1 style={{ fontSize: '2rem', fontWeight: 'bold', marginBottom: '16px' }}>
          {t('virtualGallery')}
        </h1>
        <p style={{ fontSize: '1.125rem', marginBottom: '8px' }}>
          <b>{t('clickFloorToMove')}</b><br/>
          <b>{t('clickArtworkToView')}</b>
        </p>
        <p style={{ fontSize: '1.125rem', marginBottom: '8px', marginTop: '16px' }}>
          <b>{t('toLookAround')}</b><br/>
          {t('pcControls')}<br/>
          {t('mobileControls')}
        </p>
        <p style={{ 
          fontSize: '1.125rem', 
          fontWeight: 'bold', 
          marginTop: '24px', 
          color: '#2563eb' 
        }}>
          {t('clickToStart')}
        </p>
      </div>
    </div>
  );
}

export default StartScreen;